import { render, staticRenderFns } from "./PurchaseOrderDisplay.vue?vue&type=template&id=0af8b2c9&scoped=true"
import script from "./PurchaseOrderDisplay.vue?vue&type=script&lang=ts"
export * from "./PurchaseOrderDisplay.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseOrderDisplay.vue?vue&type=style&index=0&id=0af8b2c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af8b2c9",
  null
  
)

export default component.exports